<div class="relative mb-3 w-full flex items-center gap-3">

    <!-- Flecha para re-expandir el sidebar (desktop): item flex centrado
         verticalmente junto al título. Visible solo con body.sidebar-collapsed. -->
    <button class="course-layout__expand-btn relative z-[2] shrink-0 w-7 h-7 text-[#22304C] items-center justify-center cursor-pointer rounded-full border border-[#E8EAEF] bg-white"
        type="button"
        [attr.aria-label]="'words.menu' | translate"
        (click)="expandSidebar()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="w-3.5 h-3.5"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m9 18 6-6-6-6"></path>
        </svg>
    </button>

    <!-- Flecha (solo mobile): abre el menú lateral -->
    <button class="course-layout__hamburger relative z-[2] shrink-0" type="button"
        [attr.aria-label]="'words.menu' | translate"
        (click)="toggleSidebar()">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m9 18 6-6-6-6"></path>
        </svg>
    </button>

    <!-- Botón de "más opciones": al final de la fila (derecha) -->
    <div class="relative z-[2] order-last shrink-0" *ngIf="showMenu">
        <button type="button" aria-label="Más opciones"
            (click)="toggleMenu($event)"
            class="course-layout__options-btn w-8 h-8 rounded-full border border-[#E8EAEF] bg-white flex items-center justify-center text-[#22304C] hover:bg-[#F6F7F9] transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-ellipsis-vertical w-3.5 h-3.5 text-gray-600">
                <circle cx="12" cy="12" r="1"></circle>
                <circle cx="12" cy="5" r="1"></circle>
                <circle cx="12" cy="19" r="1"></circle>
            </svg>
        </button>

        <!-- Menú desplegable (position: fixed para no recortarse con overflow:hidden) -->
        <div *ngIf="menuOpen"
            class="fixed w-48 bg-white  rounded-xl border border-[#E8EAEF] shadow-lg py-1.5"
            style="z-index: 100000;"
            [style.top.px]="menuPos.top" [style.right.px]="menuPos.right">

            <!-- Ver resultados -->
            <a [routerLink]="['/course', course?.id, 'results']" (click)="closeMenu()"
                class="flex items-center gap-3 px-4 py-2.5 text-sm !text-gray-700 hover:!text-secondary-500 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-clipboard-check w-4 h-4 shrink-0">
                    <rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="m9 14 2 2 4-4"></path>
                </svg>
                <span>{{ 'player.course.results' | translate }}</span>
            </a>

            <!-- Reset sesión (solo en modo preview) -->
            <button *ngIf="preview" type="button" (click)="resetCurrentSubscriptionSession()"
                class="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700  hover:text-secondary-500 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="23 4 23 10 17 10"></polyline>
                    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                </svg>
                <span>{{ 'player.reset-session' | translate }}</span>
            </button>

            <!-- Salir del curso: mismo estilo que el del sidebar (gris, alineado izquierda,
                 flecha). El borde superior va en el div contenedor (en el <button> no se
                 ve por el reset de border de los botones). -->
            <div>
                <button type="button" (click)="back()"
                    class="w-full flex items-center justify-start text-left gap-3 px-4 py-2.5 text-sm font-medium text-[#5F6877] hover:bg-[#F6F7F9] transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-arrow-left w-4 h-4 shrink-0" style="color: #A32D2D;">
                        <path d="m12 19-7-7 7-7"></path>
                        <path d="M19 12H5"></path>
                    </svg>
                    <span style="color: #A32D2D;">{{ 'words.leave-course' | translate }}</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Heading proyectado: ocupa el espacio restante de la fila flex -->
    <div class="min-w-0 flex-1">
        <ng-content></ng-content>
    </div>

</div>
